import { createAction, props } from '@ngrx/store';

export const initItemsPerPage = createAction('[Financial Review Matrix Component] Init Items Per Page');

export const itemsPerPageInitiated = createAction(
  '[Financial Review Effects] Items Per Page Initiated',
  props<{ itemsPerPage: number; fetchedFromSessionStore: boolean }>()
);

export const updateItemsPerPage = createAction('[Financial Review Matrix Component] Update Items Per Page', props<{ itemsPerPage: number }>());

export const updateItemsPerPageOptionsUserModification = createAction(
  '[Financial Review Effects] Update Items Per Page Options User Modification',
  props<{ isUpdatedByUser: boolean }>()
);

export const pageDataLoaded = createAction(
  '[Financial Review Matrix Component] Page Data Loaded',
  props<{ comparables: { comparableId: number; companyName: string; databaseId: number; bvdId: string }[] }>()
);

export const comparableDataLoaded = createAction(
  '[Financial Review Details Component] Comparable Data Loaded',
  props<{ comparables: { comparableId: number; companyName: string; databaseId: number; bvdId: string }[] }>()
);

export const setSelectedComparableId = createAction(
  '[Financial Review View Component] Set Selected Comparable Id',
  props<{ comparableId: number }>()
);

export const clearFinancialReviewData = createAction('[Financial Review View Component] Clear Financial Review Data');
